//This is for POS Print

import React from "react";
import "./stylePos.css";
import { currency } from "../../../MUI_components/currencyFormatterTag";
import { company } from "titum-custom/details";
import BillHeader from "Components/Print/billHeaderPos";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { PAYMENT_STATUS_CODE } from "Components/Constants/PaymentStatusCode";
import BillFooter from "Components/Print/billfooterpos";
import Barcode from "react-barcode";
import { PAYMENT_TYPE_CODE } from "Components/Constants/PaymentTypeCode";
import { Box } from "@mui/material";

const PrintBill = React.forwardRef((props, ref) => {
  const { submittedData, pageStatus } = props;
  const { stockHistories, customer, invoiceExt ,paymentReceipts } = submittedData;

  var currentDate = new Date();
  var today = currentDate.toLocaleString();

  const handleLineTotal = (qty, price, discountPer, discountAmount, vat) => {
    let totalAmount = qty * price;
    discountAmount = discountAmount * qty;
    let lineTotalAmount =
      totalAmount - totalAmount * (discountPer / 100) - discountAmount;
    //let totalWithVat = lineTotalAmount + vat/100 * lineTotalAmount;
    return lineTotalAmount;
  };

  const handleLineVatAmount = (
    qty,
    price,
    discountPer,
    discountAmount,
    vat
  ) => {
    let totalAmount = qty * price;
    discountAmount = discountAmount * qty;
    let lineTotalAmount =
      totalAmount - totalAmount * (discountPer / 100) - discountAmount;
    let totalVat = (vat / 100) * lineTotalAmount;
    return totalVat;
  };
  const billCredit =
    submittedData.totalAmount > submittedData.receivedAmount
      ? parseFloat(submittedData.totalAmount) -
        parseFloat(submittedData.receivedAmount)
      : 0;

  const totalOutStanding =
    submittedData.paidStatus === PAYMENT_STATUS_CODE.PAYMENT_NOT_DONE &&
    customer &&
    submittedData.previousBillAmount
      ? parseFloat(customer?.creditAmount ? customer.creditAmount : 0.0) -
        parseFloat(submittedData.previousBillAmount) +
        parseFloat(submittedData.totalAmount)
      : customer
      ? pageStatus.recalled
        ? customer.creditAmount
          ? customer.creditAmount
          : 0.0
        : billCredit
        ? billCredit +
          parseFloat(customer.creditAmount ? customer.creditAmount : 0)
        : customer.creditAmount
      : "0.00";
  const chequeReturnAmount = parseFloat(
    customer?.chequeReturnAmount ? customer.chequeReturnAmount : 0
  );

  function roundToNearestTen(value) {
    let roundedValue;
    roundedValue = Math.floor(parseFloat(value) / 10) * 10;
    return roundedValue;
  }
  
  const retailTotal = submittedData.stockHistories.map((props)=>parseFloat(props.retailPrice) * props.quantity ).reduce((sum, i) => sum + i, 0);

  const prsrOtstanding = parseFloat(totalOutStanding);

  function calculateTotalAmount(paymentType) {
    const amount = paymentReceipts.map((pr) =>
      pr?.modeOfPayments?.filter((row) => row.paymentTypeCode == paymentType)
    );

    let totalAmount = 0; // Changed from const to let
    if (amount.length > 0) {
      totalAmount = amount[0]
        .map((row) => parseFloat(row.amount))
        .reduce((sum, amount) => sum + amount, 0);
    }

    return totalAmount;
  }
//----------------------------
let cashPaymentCode = PAYMENT_TYPE_CODE.CASH_PAYMENT;
  let chequePaymentCode = PAYMENT_TYPE_CODE.CHEQUE_PAYMENT;
  let bankeDpositCode = PAYMENT_TYPE_CODE.BANK_DEPOSIT;
  let cardPaymentCode = PAYMENT_TYPE_CODE.CARD_PAYMENT;
  let overPaymentCode = PAYMENT_TYPE_CODE.OVER_PAYMENT;
  let returnPaymentCode = PAYMENT_TYPE_CODE.RETURN_AMOUT;
  let onlineTransferCode = PAYMENT_TYPE_CODE.ONLINE_TRANSFER;
  // end of define payment type code

  //define function for calculatetion
  function calculateTotalAmount(paymentType) {
    const amount = paymentReceipts.map((pr) =>
      pr?.modeOfPayments?.filter((row) => row.paymentTypeCode == paymentType)
    );
  
    let totalAmount = 0; // Changed from const to let
    if (amount.length > 0) {
      totalAmount = amount[0].map((row) => parseFloat(row.amount))
        .reduce((sum, amount) => sum + amount, 0);
    }
  
    return totalAmount;
  }

  const totalCashAmount = calculateTotalAmount(cashPaymentCode);
  const totalChequeAmount = calculateTotalAmount(chequePaymentCode);
  const totalBankAmount = calculateTotalAmount(bankeDpositCode);
  const totalCardAmount = calculateTotalAmount(cardPaymentCode);
  const totalOverPaymentAmount = calculateTotalAmount(overPaymentCode);
  const totalRtnAmount = calculateTotalAmount(returnPaymentCode);
  const totalOnlineTransferAmount = calculateTotalAmount(onlineTransferCode);
//----------------------------
  //define function for calculatetion

  // cal the calculateTotalAmount function fro create
  // const totalCashAmount = calculateTotalAmount(cashPaymentCode);
  // const totalChequeAmount = calculateTotalAmount(chequePaymentCode);
  // const totalBankAmount = calculateTotalAmount(bankeDpositCode);
  // const totalCardAmount = calculateTotalAmount(cardPaymentCode);
  // const totalOverPaymentAmount = calculateTotalAmount(overPaymentCode);
  // const totalRtnAmount = calculateTotalAmount(returnPaymentCode);
  // const totalOnlineTransferAmount = calculateTotalAmount(onlineTransferCode);


  // Calculate the outstandingWithCheque
  const outstandingWithCheque = chequeReturnAmount + prsrOtstanding;

  var now = new Date();

  // Extract the date components
  var year = now.getFullYear();
  var month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1 and pad with 0 if necessary
  var day = String(now.getDate()).padStart(2, "0");
  var hours = String(now.getHours()).padStart(2, "0");
  var minutes = String(now.getMinutes()).padStart(2, "0");
  var seconds = String(now.getSeconds()).padStart(2, "0");
  const numberOfQuantity = stockHistories
    .map((props) => parseFloat(props["quantity"] ? props["quantity"] : 0))
    .reduce((sum, i) => sum + i, 0);

  // Concatenate the components
  var today =
    year +
    "-" +
    month +
    "-" +
    day +
    " " +
    hours +
    ":" +
    minutes +
    ":" +
    seconds;

  return (
    <div className ref={ref}>
      <div className="billBody">
        <BillHeader />
        <div align="center">
          <strong>{`INVOICE ${pageStatus.recalled ? "Re-Printed" : ""}`}</strong>
        </div>
        <div className="text-center " style={{ fontSize: 12 }}>
          <div style={{ textAlign: "center", fontSize: 12 }}>
            {company.address}
          </div>
          <div style={{ textAlign: "center", fontSize: 12 }}>
            TEL: {company.phone} / {company.phone2}{" "}
          </div>
        </div>
        <div style={{ borderTop: "1px solid #000", marginBottom: 2 }}></div>
        <div>
          <div className="flex">
            <strong style={{ fontSize: 11 }}> INVOICE: </strong> &nbsp;
            <strong style={{ fontSize: 11 }}>
              {submittedData.code ? submittedData.code : props.invoiceCode}
            </strong>
          </div>

          <div className="flex">
            <strong style={{ fontSize: 11 }}>CUSTOMER: </strong>&nbsp;
            <strong style={{ fontSize: 11 }}>
              {" "}
              {customer?.firstName ? customer.firstName : "Cash"}
            </strong>
          </div>

          <div className="flex">
            <strong style={{ fontSize: 11 }}>DATE: </strong>&nbsp;
            <strong style={{ fontSize: 11 }}>
              {pageStatus.adding
                ? today
                : submittedData.createdAt
                ? submittedData.createdAt
                : submittedData.dateTime}
            </strong>
          </div>
          <div className="flex">
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.REMARKS} : </strong>
            &nbsp;
            <strong style={{ fontSize: 11 }}>{submittedData.remarks}</strong>
          </div>
        </div>
        <div style={{ borderBottom: "1px solid #000", marginTop: 2 }}></div>
        <table>
          <thead>
            <tr style={{ borderBottom: "1px solid #000" }}>
              <th>#</th>
              <th width="80%">DEC</th>
              <th align="right" style={{ paddingLeft: 10 }}>
                QTY
              </th>
              <th align="right" style={{ paddingLeft: 10 }}>
                PRI{" "}
              </th>
              <th align="right" style={{ paddingLeft: 10 }}>
                D.%
              </th>
              <th align="right" style={{ paddingLeft: 10 }}>
                {" "}
                D.Rs
              </th>
              <th align="right" style={{ paddingLeft: 10 }}>
                AMT
              </th>
            </tr>
          </thead>

          <tbody>
            {stockHistories
              .filter((i) => i.quantity > 0)
              .map((row, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td> {index + 1}.</td>
                    <td colSpan="6">
                    {row.itemMaster.barcode} - {row.name ? row.name : row.itemMaster.name}
                    </td>
                  </tr>
                  <tr>
                    <td align="right" colSpan="3">
                      {parseFloat(row.quantity)}
                    </td>
                    <td align="right" style={{ paddingLeft: 12 }}>
                      {row.retailPrice}
                    </td>
                    <td align="right" style={{ paddingLeft: 12 }}>
                      {row.discountPercentage}
                    </td>
                    <td align="right" style={{ paddingLeft: 12 }}>
                      {row.discountAmount}
                    </td>

                    <td align="right" style={{ paddingLeft: 12 }}>
                      <strong>
                        {currency(roundToNearestTen(
                          handleLineTotal(
                            row.quantity,
                            row.retailPrice,
                            row.discountPercentage,
                            row.discountAmount
                          )
                        )
                        )}
                      </strong>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        </table>
        <div style={{ borderBottom: "1px solid #000" }}></div>
        <div className="flex-print  mb  justify-content-spaceBetween">
          <div>
            <strong>{COLUMNS_NAME.SUB_TOTAL} : </strong>
          </div>

          <div>
            <strong> {currency(submittedData.subTotalAmount)}</strong>
          </div>
        </div>

        <div className="flex-print  justify-content-spaceBetween">
          <div>
            <strong style={{ fontSize: 11 }}>
              Bill Total :
            </strong>
          </div>

          <div>
            <strong style={{ fontSize: 11 }}>
              {currency(retailTotal)}
            </strong>
          </div>
        </div>
                <div className="flex-print  justify-content-spaceBetween">
          <div>
            <strong style={{ fontSize: 11 }}>
              {COLUMNS_NAME.DISCOUNT_TOTAL}:
            </strong>
          </div>
          <div>
            <strong style={{ fontSize: 11 }}>
              {currency(submittedData.discountTotal)}
            </strong>
          </div>
        </div>
        <div
          className="flex-print  mb  justify-content-spaceBetween"
          style={{ borderTop: "1px solid #000", borderBottom: "1px solid #000" }}
        >

          <strong style={{ fontSize: 16 }}>{COLUMNS_NAME.LAST_TOTAL}</strong>

          <strong style={{ fontSize: 16 }}>
            {currency(submittedData.totalAmount)}
          </strong>
        </div>
        <div className="flex-print  justify-content-spaceBetween">
          <div>
            <strong style={{ fontSize: 11 }}>
              {COLUMNS_NAME.PAYMENT_RECIEVED} :
            </strong>
          </div>

          <div>
            <strong style={{ fontSize: 11 }}>
              {currency(roundToNearestTen(
                invoiceExt
                ? submittedData.receivedAmount - roundToNearestTen(invoiceExt.returnWhileInvoice)
                : submittedData.receivedAmount
              ))}
            </strong>
          </div>
        </div>
        <div className="flex-print  justify-content-spaceBetween">
          <div>
            <strong style={{ fontSize: 11 }}>
              {COLUMNS_NAME.RETURN_AMOUNT} :
            </strong>
          </div>

          <div>
            <strong style={{ fontSize: 11 }}>
              {invoiceExt ? currency(roundToNearestTen(invoiceExt.returnWhileInvoice)) : "0.00"}
            </strong>
          </div>
        </div>

        <div className="flex-print  justify-content-spaceBetween">
          <div>
            <strong style={{ fontSize: 11 }}>
              {COLUMNS_NAME.BALANCE_GIVEN} :
            </strong>
          </div>
          <div>
            <strong style={{ fontSize: 11 }}>
              {roundToNearestTen(submittedData.receivedAmount) > submittedData.totalAmount
                ? `${currency(
                  roundToNearestTen(submittedData.receivedAmount) - submittedData.totalAmount
                  )}`
                : "0.00"}
            </strong>
          </div>
        </div>
        {/* <table>
              <Box sx={{ marginLeft: 10, marginRight: 10 }} p={2}>
                <>
                  <div style={{ fontSize: 12, textAlign: "center" }}>
                    {" "}
                    <strong>Mode of Payment</strong>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    {totalCashAmount !== 0 && (
                      <div>
                        <p style={{ fontSize: 12, marginRight: "10px" }}>
                          {COLUMNS_NAME.CASH_AMOUNT} :{" "}
                          {currency(totalCashAmount)}
                        </p>
                      </div>
                    )}

                    {totalChequeAmount !== 0 && (
                      <div>
                        <p style={{ fontSize: 12, marginRight: "10px" }}>
                          {COLUMNS_NAME.CHEQUE_AMOUNT} :{" "}
                          {currency(totalChequeAmount)}
                        </p>
                      </div>
                    )}

                    {totalBankAmount !== 0 && (
                      <div>
                        <p style={{ fontSize: 12, marginRight: "10px" }}>
                          {COLUMNS_NAME.BANK_DEPOSIT} :{" "}
                          {currency(totalBankAmount)}
                        </p>
                      </div>
                    )}

                    {totalCardAmount !== 0 && (
                      <div>
                        <p style={{ fontSize: 12, marginRight: "10px" }}>
                          {COLUMNS_NAME.CARD_PAYMENT} :{" "}
                          {currency(totalCardAmount)}
                        </p>
                      </div>
                    )}

                    {totalOverPaymentAmount !== 0 && (
                      <div>
                        <p style={{ fontSize: 12, marginRight: "10px" }}>
                          {COLUMNS_NAME.OVERPAYMENT} :{" "}
                          {currency(totalOverPaymentAmount)}
                        </p>
                      </div>
                    )}

                    {totalRtnAmount !== 0 && (
                      <div>
                        <p style={{ fontSize: 12, marginRight: "10px" }}>
                          {COLUMNS_NAME.RETURN_AMOUNT} :{" "}
                          {currency(totalRtnAmount)}
                        </p>
                      </div>
                    )}

                    {totalOnlineTransferAmount !== 0 && (
                      <div>
                        <p style={{ fontSize: 12 }}>
                          {COLUMNS_NAME.ONLINE_TRANSFER} :{" "}
                          {currency(totalOnlineTransferAmount)}
                        </p>
                      </div>
                    )}
                  </div>
                </>
              </Box>
            </table> */}
        <div className="flex-print  justify-content-spaceBetween">
          <div>
            {COLUMNS_NAME.NUMBER_OF_ITEM} :
            {/* {COLUMNS_NAME.NUMBER_OF_QUANTITY} : {stockHistories.length} / {numberOfQuantity} */}
          </div>
          <div>{stockHistories.length}</div>
        </div>
        <div className="flex-print  justify-content-spaceBetween">
          <div>
            {COLUMNS_NAME.NUMBER_OF_QUANTITY} :
            {/* {COLUMNS_NAME.NUMBER_OF_QUANTITY} : {stockHistories.length} / {numberOfQuantity} */}
          </div>
          <div>{numberOfQuantity}</div>
        </div>
        <table>
              <Box p={2}>
                <>   
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    {totalCashAmount !== 0 && (
                      <div className="flex-print  justify-content-spaceBetween">
                        <p style={{ fontSize: 11, marginRight: "10px" }}>
                          {COLUMNS_NAME.CASH_AMOUNT} : {currency(totalCashAmount)}
                        </p>
                      </div>
                    )}

                    {totalChequeAmount !== 0 && (
                      <div className="flex-print  justify-content-spaceBetween">
                        <p style={{ fontSize: 11, marginRight: "10px" }}>
                          {COLUMNS_NAME.CHEQUE_AMOUNT} : {currency(totalChequeAmount)}
                        </p>
                      </div>
                    )}

                    {totalBankAmount !== 0 && (
                      <div className="flex-print  justify-content-spaceBetween">
                        <p style={{ fontSize: 12, marginRight: "10px" }}>
                          {COLUMNS_NAME.BANK_DEPOSIT} : {currency(totalBankAmount)}
                        </p>
                      </div>
                    )}

                    {totalCardAmount !== 0 && (
                      <div className="flex-print  justify-content-spaceBetween">
                        <p style={{ fontSize: 12, marginRight: "10px" }}>
                          {COLUMNS_NAME.CARD_PAYMENT} : {currency(totalCardAmount)}
                        </p>
                      </div>
                    )}

                    {totalOverPaymentAmount !== 0 && (
                      <div className="flex-print  justify-content-spaceBetween">
                        <p style={{ fontSize: 12, marginRight: "10px" }}>
                          {COLUMNS_NAME.OVERPAYMENT} : {currency(totalOverPaymentAmount)}
                        </p>
                      </div>
                    )}

                    {totalRtnAmount !== 0 && (
                      <div className="flex-print  justify-content-spaceBetween">
                        <p style={{ fontSize: 12, marginRight: "10px" }}>
                          {COLUMNS_NAME.RETURN_AMOUNT} : {currency(totalRtnAmount)}
                        </p>
                      </div>
                    )}

                    {totalOnlineTransferAmount !== 0 && (
                      <div className="flex-print  justify-content-spaceBetween">
                        <p style={{ fontSize: 12 }}>
                          {COLUMNS_NAME.ONLINE_TRANSFER} : {currency(totalOnlineTransferAmount)}
                        </p>
                      </div>
                    )}
                  </div>
                </>
              </Box>
            </table>
        {
          /* <div className="flex-print  justify-content-spaceBetween">
          <div>
            <strong style={{ fontSize: 11 }}>
              {COLUMNS_NAME.BALANCE_GIVEN} :
            </strong>
          </div>
          <div>
            <strong style={{ fontSize: 11 }}>
              {submittedData.receivedAmount > submittedData.totalAmount
                ? `${currency(
                    submittedData.receivedAmount - submittedData.totalAmount
                  )}`
                : "0.00"}
            </strong>
          </div>
        </div>

        <div className="flex-print  justify-content-spaceBetween">
          <div>
            <strong style={{ fontSize: 11 }}>
              {COLUMNS_NAME.TOTAL_OUTSTANDING} :
            </strong>
          </div>

          <div>
            <strong>{currency(totalOutStanding)} </strong>
          </div>
        </div>

        <div className="flex-print  justify-content-spaceBetween">
          <div>
            <strong style={{ fontSize: 11 }}>
              {COLUMNS_NAME.CHEQUE_RETURN_AMOUNT} :
            </strong>
          </div>

          <div>
            <strong>
              {customer?.chequeReturnAmount
                ? customer.chequeReturnAmount
                : "0.00"}{" "}
            </strong>
          </div>
        </div>

        <div className="flex-print  justify-content-spaceBetween">
          <div>
            <strong style={{ fontSize: 11 }}>
              {COLUMNS_NAME.OUTSTANDING_WITH_CHEQUE_RETURN} :
            </strong>
          </div>

          <div>
            <strong>{currency(outstandingWithCheque)}</strong>
          </div>
        </div>

        {invoiceExt && (
          <div className="flex-print  justify-content-spaceBetween">
            <div>
              <strong style={{ fontSize: 11 }}>
                {" "}
                Return Amount While Invoice :
              </strong>
            </div>

            <div>
              <strong>{currency(invoiceExt?.returnWhileInvoice)}</strong>
            </div>
          </div>
        )}*/
          <div style={{ borderBottom: "1px solid #000" }}></div>
        }
        {/* PRINT WITH BIZX FOOTER */}{" "}
        <small className="mt  text-center">
          <div style={{ fontSize: 11 }}>
            EXCHANGE WITH IN 3 DAYS, NO REFUND. <br />
            THANK YOU FOR SHOPPING WITH US.
            <br />
          </div>
        </small>
       
      
        <small className="text-center">
          <div style={{ fontSize: 11 }}>
          <div>
              <Barcode
              fontSize={12}
              width={1}
              height={30}
              marginLeft={1}
              marginBottom={2}
              value={submittedData.code ? submittedData.code : props.invoiceCode}
              format="CODE128" // Hide the value from the barcode component
            />
          </div> 
            THANK YOU COME AGAIN <br />
            SOLUTION BY TITUM (PVT) LTD <br />
            {TitumDetails.WEB} | {TitumDetails.EMAIL_ID} {TitumDetails.PHONE_NO}
          </div>
        </small>
        <BillFooter />
      </div>
    </div>
  );
});

export default PrintBill;

// mt-margin top mb-marigin bottom
// justify-content-spaceBetween - vertical space
// #000 - black
